export const CLEAR_STATE = 'CLEAR_STATE';
export const INITIATE_LEASE_APPLICATION = 'INITIATE_LEASE_APPLICATION';
export const INITIATE_LEASE_APPLICATION_SUCCESS = 'INITIATE_LEASE_APPLICATION_SUCCESS';
export const INITIATE_LEASE_MULTIPLE_APPLICATION_SUCCESS = 'INITIATE_LEASE_MULTIPLE_APPLICATION_SUCCESS';
export const INITIATE_LEASE_APPLICATION_FAILURE = 'INITIATE_LEASE_APPLICATION_FAILURE';

export const INITIATE_RENEWAL_AMENDMENT_APPLICATION = 'INITIATE_RENEWAL_AMENDMENT_APPLICATION';
export const INITIATE_RENEWAL_AMENDMENT_APPLICATION_SUCCESS = 'INITIATE_RENEWAL_AMENDMENT_APPLICATION_SUCCESS';

export const FETCH_LEASE_WORKFLOW = 'FETCH_LEASE_WORKFLOW';
export const FETCH_LEASE_WORKFLOW_SUCCESS = 'FETCH_LEASE_WORKFLOW_SUCCESS';

export const FETCH_LEASE_APPLICATION_DETAILS = 'FETCH_LEASE_APPLICATION_DETAILS';
export const FETCH_LEASE_APPLICATION_DETAILS_SUCCESS = 'FETCH_LEASE_APPLICATION_DETAILS_SUCCESS';

export const FETCH_PREMISE_DETAILS = 'FETCH_PREMISE_DETAILS';
export const FETCH_PREMISE_DETAILS_SUCCESS = 'FETCH_PREMISE_DETALS_SUCCESS';
export const FETCH_PREMISE_DETAILS_ERROR = 'FETCH_PREMISE_DETAILS_ERROR';
export const FETCH_RENEWAL_PREMISE_DETAILS_SUCCESS = 'FETCH_RENEWAL_PREMISE_DETAILS_SUCCESS';
export const FETCH_RENEWAL_PREMISE_DETAILS_ERROR = 'FETCH_RENEWAL_PREMISE_DETAILS_ERROR';
export const FETCH_AMENDMENT_PREMISE_DETAILS_SUCCESS = 'FETCH_AMENDMENT_PREMISE_DETAILS_SUCCESS';
export const FETCH_AMENDMENT_PREMISE_DETAILS_ERROR = 'FETCH_AMENDMENT_PREMISE_DETAILS_ERROR';

export const FETCH_PERSON_DETAILS = 'FETCH_PERSON_DETAILS';
export const FETCH_PERSON_DETAILS_SUCCESS = 'FETCH_PERSON_DETAILS_SUCCESS';

export const FETCH_LEASE_COMPANY_DETAILS = 'FETCH_LEASE_COMPANY_DETAILS';
export const FETCH_LEASE_COMPANY_DETAILS_SUCCESS = 'FETCH_LEASE_COMPANY_DETAILS_SUCCESS';

export const FETCH_LEASE_RESERVE_DETAILS = 'FETCH_LEASE_RESERVE_DETAILS';
export const FETCH_LEASE_RESERVE_DETAILS_SUCCESS = 'FETCH_LEASE_RESERVE_DETAILS_SUCCESS';

export const SUBMIT_LEASE_APPLICATION = 'SUBMIT_LEASE_APPLICATION';
export const SUBMIT_LEASE_APPLICATION_SUCCESS = 'SUBMIT_LEASE_APPLICATION_SUCCESS';

export const ADD_OCCUPANT = 'ADD_OCCUPANT';
export const ADD_OCCUPANT_SUCCESS = 'ADD_OCCUPANT_SUCCESS';

export const UPDATE_OCCUPANT_SUCCESS = 'UPDATE_OCCUPANT_SUCCESS';

export const FETCH_OCCUPANT_RELATIONS = 'FETCH_OCCUPANT_RELATIONS';

export const REMOVE_OCCUPANT = 'REMOVE_OCCUPANT';
export const REMOVE_OCCUPANT_SUCCESS = 'REMOVE_OCCUPANT_SUCCESS';

export const UPLOAD_LEASE_DOCUMENT = 'UPLOAD_LEASE_DOCUMENT';
export const UPLOAD_LEASE_DOCUMENT_SUCCESS = 'UPLOAD_LEASE_DOCUMENT_SUCCESS';

export const DELETE_LEASE_DOCUMENT = 'DELETE_LEASE_DOCUMENT';
export const DELETE_LEASE_DOCUMENT_SUCCESS = 'DELETE_LEASE_DOCUMENT_SUCCESS';

export const DOWNLOAD_LEASE_DOCUMENT = 'DOWNLOAD_LEASE_DOCUMENT';
export const DOWNLOAD_LEASE_DOCUMENT_SUCCESS = 'DOWNLOAD_LEASE_DOCUMENT_SUCCESS';

export const CHECKOUT_LEASE_APPLICATION = 'CHECKOUT_LEASE_APPLICATION';
export const CHECKOUT_LEASE_APPLICATION_SUCCESS = 'CHECKOUT_LEASE_APPLICATION_SUCCESS';

export const ADD_TO_LEASE_ERROR = 'ADD_TO_LEASE_ERROR';
export const ADD_TO_LEASE_ERROR_INITITATE = 'ADD_TO_LEASE_ERROR_INITITATE';

export const FETCH_LEASE_CONTRACTS = 'FETCH_LEASE_CONTRACTS';
export const FETCH_LEASE_CONTRACTS_SUCCESS = 'FETCH_LEASE_CONTRACTS_SUCCESS';

export const FETCH_AMENDMENT_FEE = 'FETCH_AMENDMENT_FEE';
export const FETCH_AMENDMENT_FEE_SUCCESS = 'FETCH_AMENDMENT_FEE_SUCCESS';

export const FETCH_LEASE_OCCUPANT = 'FETCH_LEASE_OCCUPANT';
export const FETCH_LEASE_OCCUPANT_SUCCESS = 'FETCH_LEASE_OCCUPANT_SUCCESS';

export const UPLOAD_LEASE_CLOSURE_DOCUMENT = 'UPLOAD_LEASE_CLOSURE_DOCUMENT';
export const UPLOAD_LEASE_CLOSURE_DOCUMENT_SUCCESS = 'UPLOAD_LEASE_CLOSURE_DOCUMENT_SUCCESS';

export const ADD_LEASE_PRIMARY_LESSOR = 'ADD_LEASE_PRIMARY_LESSOR';
export const ADD_LEASE_PRIMARY_LESSOR_SUCCESS = 'ADD_LEASE_PRIMARY_LESSOR_SUCCESS';

export const DISCARD_LEASE_APPLICATION = 'DISCARD_LEASE_APPLICATION';
export const DISCARD_LEASE_APPLICATION_SUCCESS = 'DISCARD_LEASE_APPLICATION_SUCCESS';

export const LEASE_SERVICE_ACTION_START = 'LEASE_SERVICE_ACTION_START';
export const LEASE_SERVICE_ACTION_SUCCESS = 'LEASE_SERVICE_ACTION_SUCCESS';
export const GENERAL_LEASE_ERROR = 'GENERAL_LEASE_ERROR';
export const CHANGE_LEASE_PROPERTY = 'CHANGE_LEASE_PROPERTY';
export const CHANGE_LEASE_FORM = 'CHANGE_LEASE_FORM';
export const CHANGE_LEASE_WORKFLOW_STEP = 'CHANGE_LEASE_WORKFLOW_STEP';
export const SET_LEASE_REGISTRATION_FORM = 'SET_LEASE_REGISTRATION_FORM';
export const SET_LEASE_RENEWAL_FORM = 'SET_LEASE_RENEWAL_FORM';
export const SET_LEASE_AMENDMENT_FORM = 'SET_LEASE_AMENDMENT_FORM';
export const RESET_LEASE_APPLICATION = 'RESET_LEASE_APPLICATION';
export const SET_LEASE_FORM_ERROR = 'SET_LEASE_FORM_ERROR';

export const FETCH_LEASE_SUCCESS_APPLICATION_DETAILS_SUCCESS = 'FETCH_LEASE_SUCCESS_APPLICATION_DETAILS_SUCCESS';

export const REMOVE_UNIT = 'REMOVE_UNIT';
export const REMOVE_UNIT_SUCCESS = 'REMOVE_UNIT_SUCCESS';
export const REMOVE_LAST_UNIT = 'REMOVE_LAST_UNIT';

export const ADD_LEASE_PROPERTIES = 'ADD_LEASE_PROPERTIES';
export const ADD_LEASE_PROPERTIES_SUCCESS = 'ADD_LEASE_PROPERTIES_SUCCESS';
export const ADD_LEASE_PROPERTIES_ERROR = 'ADD_LEASE_PROPERTIES_ERROR';
export const ADD_LEASE_PROPERTIES_VALIDATION_ERROR = 'ADD_LEASE_PROPERTIES_VALIDATION_ERROR';

export const FETCH_LEASABLE_PROPERTIES = 'FETCH_LEASABLE_PROPERTIES';
export const FETCH_LEASABLE_PROPERTIES_SUCCESS = 'FETCH_LEASABLE_PROPERTIES_SUCCESS';
export const FETCH_LEASABLE_PROPERTIES_ERROR = 'FETCH_LEASABLE_PROPERTIES_ERROR';

export const FETCH_PLOTS = 'FETCH_PLOTS';
export const FETCH_PLOTS_SUCCESS = 'FETCH_PLOTS_SUCCESS';

export const TOGGLE_DIALOGUE_CANCEL = 'TOGGLE_DIALOGUE_CANCEL';

export const FETCH_LEASE_OCCUPANTS = 'FETCH_LEASE_OCCUPANTS';
export const ADD_MULTIPLE_OCCUPANT = 'ADD_MULTIPLE_OCCUPANT';

export const UPDATE_MULTIPLE_OCCUPANTS = 'UPDATE_MULTIPLE_OCCUPANTS';

export const FETCH_SELECTED_PROPERTIES = 'FETCH_SELECTED_PROPERTIES';
export const FETCH_SELECTED_PROPERTIES_SUCCESS = 'FETCH_SELECTED_PROPERTIES_SUCCESS';
export const FETCH_SELECTED_PROPERTIES_ERROR = 'FETCH_SELECTED_PROPERTIES_ERROR';

export const FETCH_ALL_PREMISE_DETAILS_SUCCESS = 'FETCH_ALL_PREMISE_DETAILS_SUCCESS';
export const FETCH_COMPANY_TRADE_DETAILS = 'FETCH_COMPANY_TRADE_DETAILS';
export const FETCH_COMPANY_TRADE_DETAILS_SUCCESS = 'FETCH_COMPANY_TRADE_DETAILS_SUCCESS';
export const LEASE_FETCH_CONTRACT_AMOUNT = 'LEASE_FETCH_CONTRACT_AMOUNT';
export const LEASE_RESET_ERROR = 'LEASE_RESET_ERROR';

export const SET_ALLOW_SUB_CONTRACT = 'SET_ALLOW_SUB_CONTRACT';

export const SET_IS_OWNER_APPROVAL_REQUIRED = 'SET_IS_OWNER_APPROVAL_REQUIRED';

export const SET_ALLOW_CLEAR_SUBLEASE_AGREEMENT = 'SET_ALLOW_CLEAR_SUBLEASE_AGREEMENT';

export const SET_SUB_LEASE_PERMISSIONS = 'SET_SUB_LEASE_PERMISSIONS';

export const FETCH_REPRESENTATIVE_DETAILS_LOADING = 'FETCH_REPRESENTATIVE_DETAILS_LOADING';

export const FETCH_REPRESENTATIVE_DETAILS_SUCCESS = 'FETCH_REPRESENTATIVE_DETAILS_SUCCESS';

export const FETCH_REPRESENTATIVE_DETAILS_ERROR = 'FETCH_REPRESENTATIVE_DETAILS_ERROR';
